import * as devConfig from "../../app/configs/devConfig";
import { getPortalSession } from "./portalSession";

/** Uploads one file to the client's portal, reporting progress (0-100). */
export const uploadPortalFile = (
  customerId: string,
  file: File,
  note: string,
  onProgress: (percent: number) => void,
  folderId?: string | null,
): Promise<void> =>
  new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open(
      "POST",
      `${devConfig.getServerBaseUrlForEnv()}/api/portal/clients/${customerId}/files`,
    );
    const session = getPortalSession();
    if (session)
      xhr.setRequestHeader("Authorization", `Bearer ${session.token}`);
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable)
        onProgress(Math.min(99, Math.round((e.loaded / e.total) * 100)));
    };
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        onProgress(100);
        resolve();
      } else if (xhr.status === 401) {
        reject(
          Object.assign(new Error("Please sign in again."), { status: 401 }),
        );
      } else if (xhr.status === 413) {
        reject(new Error(`"${file.name}" is too large to upload.`));
      } else {
        const text = (xhr.responseText || "").trim();
        reject(
          new Error(
            text && !text.startsWith("<") && text.length < 300
              ? text
              : `"${file.name}" couldn't be uploaded. Please try again.`,
          ),
        );
      }
    };
    xhr.onerror = () =>
      reject(
        new Error(
          "We can't reach the portal right now. Check your connection and try again.",
        ),
      );
    const body = new FormData();
    body.append("file", file);
    if (note.trim()) body.append("note", note.trim());
    if (folderId) body.append("folderId", folderId);
    xhr.send(body);
  });
